import React, { Component } from "react";
import PimaMap from "./PimaMap";
import TestCenters from "./TestCenters";

class LandingTC extends Component {
  render() {
    return (
      <div className="row">
        <div
          className="col-lg-3 col-md-4 responsive-view fix-height"
          id="filtering"
          style={{ background: "#f4f4f4" }}
        >
          <TestCenters />
        </div>
        <div className="col-lg-9 col-md-8 mb-4" style={{ padding: 0 }}>
          <h6 className="my-4 d-md-none">
            <a
              style={{
                color: "black",
                paddingLeft: "5px",
                paddingRight: "5px",
                textDecoration: "underline",
              }}
              href="#filtering"
            >
              Find Your Test Center
            </a>
          </h6>
          <PimaMap />
        </div>
      </div>
    );
  }
}
export default LandingTC;
